module.exports = __webpack_public_path__ + "static/media/weather-app.d3a0a421.png";